import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Gallery.css";

export default function Gallery() {
  const [categories, setCategories] = useState([]);
  const [images, setImages] = useState([]);
  const [activeCategory, setActiveCategory] = useState("");

  const API_BASE = "https://news.cubixsystems.com/myapp-ks/api";
  // const API_BASE = "http://localhost/myapp-ks/api";

  // 🔹 Fetch categories
  useEffect(() => {
    axios
      .get(`${API_BASE}/fetch_categories.php`)
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data.data)
          ? res.data.data
          : [];

        setCategories(data);

        // ✅ Automatically select first category
        if (data.length > 0) {
          setActiveCategory(data[0].id);
        }
      })
      .catch(() => setCategories([]));
  }, []);

  // 🔹 Fetch images by category
  useEffect(() => {
    if (!activeCategory) return;

    axios
      .get(`${API_BASE}/fetch_gallery.php?category_id=${activeCategory}`)
      .then((res) => {
        setImages(Array.isArray(res.data) ? res.data : []);
      })
      .catch(() => setImages([]));
  }, [activeCategory]);

  return (
    <div className="gallery-container-1">
      <h3 style={{ fontWeight: "400", color: "maroon" }}>Events</h3>

      {/* CATEGORY BUTTONS */}
      <div className="category-tabs">
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={activeCategory === cat.id ? "active" : ""}
            onClick={() => setActiveCategory(cat.id)}
          >
            {cat.category_name}
          </button>
        ))}
      </div>

      {/* IMAGE GRID */}
      <div className="gallery-grid">
        {images.length === 0 ? (
          <p>No images found</p>
        ) : (
          images.map((img) => (
            <div className="gallery-item" key={img.id}>
              <img
                // src={`https://spst.in/myapp/uploads/gallery/${img.image_name}`}
                src={`https://news.cubixsystems.com/myapp-ks/uploads/gallery/${img.image_name}`}
                alt=""
              />
            </div>
          ))
        )}
      </div>
    </div>
  );
}
